import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ScriptLoader from 'react-script-loader-hoc';

import SETTINGS from '../settings';

const withFacebook = Component => {
  const WrappedComponent = ({ scriptsLoaded, scriptsLoadedSuccessfully, ...props }) => {
    const [isFbInited, setIsFbInited] = useState(false);

    const hanleOnSucessFullyInit = () => {
      setTimeout(() => {
        setIsFbInited(true);
      }, 500);
    };

    useEffect(() => {
      if (scriptsLoadedSuccessfully) {
        if (window.isFbSuccessfullyInited) {
          hanleOnSucessFullyInit();
        } else {
          window.fbAsyncInit = () => {
            window.FB.init({
              appId: SETTINGS.FACEBOOK_APP_ID,
              autoLogAppEvents: true,
              xfbml: true,
              version: 'v12.0',
            });

            hanleOnSucessFullyInit();
            window.isFbSuccessfullyInited = true;
          };
        }
      }
    }, [scriptsLoadedSuccessfully]);

    return <Component {...props} fb={isFbInited ? window.FB : undefined} />;
  };

  WrappedComponent.getInitialProps = async ctx => {
    if (Component.getInitialProps) {
      return Component.getInitialProps(ctx);
    }

    return {};
  };

  WrappedComponent.propTypes = {
    scriptsLoaded: PropTypes.bool,
    scriptsLoadedSuccessfully: PropTypes.bool,
  };

  return ScriptLoader('https://connect.facebook.net/en_US/sdk.js')(WrappedComponent);
};

export default withFacebook;
